import { YMaps, Map, Placemark, ZoomControl } from "@pbe/react-yandex-maps";
import useMobile from "../../../hooks/useMobile";

const YaMap = ({ coordinate }) => {
  const isMobile = useMobile(860);

  return (
    <>
      <YMaps>
        <div className="map__container">
          <Map
            defaultState={{
              center: [coordinate[0], coordinate[1]],
              zoom: 16.3,
            }}
            width={`${isMobile ? "90vw" : "800px"}`}
            height={"500px"}
          >
            <ZoomControl />
            <Placemark geometry={[coordinate[0], coordinate[1]]} />
          </Map>
        </div>
      </YMaps>
    </>
  );
};

export default YaMap;
